<template>
    <div>
        <v-autocomplete
            v-model="valeur"
            :label="label"
            :loading="loading"
            :items="paySectionStore.paySections"
            item-value="id"
            item-text="codeLabel"
            outlined
            dense
            :multiple="multiple"
            :chips="multiple"
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :clearable="!readonly"
            @click:clear="clear"
            @change="save"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import {usePaySectionStore} from "@/stores/PaySection";
import axios from "axios";

export default {
    name: "StrPaySectionAutocomplete",
    props: {
        value: [Number, Array],
        label: String,
        readonly: Boolean,
        multiple: Boolean,
        rules: Array,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor, loading} = useSharedData();
        const paySectionStore = usePaySectionStore();

        const valeur = ref(null);


        function findAll() {
            loading.value = true;
            axios.get('/paySections').then(response => {
                paySectionStore.setPaySections(response.data);
            }).finally(() => {
                loading.value = false;
            })
        }

        function save() {
            emit('input', valeur.value);
        }

        function clear() {
            valeur.value = null;
            emit('input', null);
        }

        watch(() => props.value, () => {
            valeur.value = props.value;
        }, {immediate: true});

        onMounted(() => {
            if (paySectionStore.paySections.length === 0)
                findAll();
        })

        return {
            inputColor,
            backgroundColor,
            loading,
            valeur,
            paySectionStore,
            save,
            clear,
        }
    }
}
</script>

<style scoped>

</style>